export default {
	section_banner: {
		title: {
			one: 'A Safe & Fun Way',
		},
		main_title: {
			one: 'To Remittance Online',
		},
		paragraph: {
			one: 'It is a simple way to quickly remit money to family and friends from almost anywhere in the world.',
		},
		cta_buttons: {
			one: 'Get Started',
			two: 'Download App',
		},
	},
	qr_pay: {
		label: 'Transfer Optimization',
		title: {
			one: 'Get The Most Out Of ',
			two: 'All Transfers',
		},
		paragraph:
			'With JPWorldPay, every transfer is optimized for speed, security, and convenience. Whether you are sending funds locally or across borders, you enjoy low fees, real-time tracking, and full transparency.',
		white_box_1st: {
			heading: 'Two-Way Messages',
			paragraph:
				'Exchange messages to check if the payment is correctly made between friends.',
		},
		white_box_2nd: {
			heading: 'Free Options',
			paragraph:
				'Use your JPWorldPay point card to check the balance and send money overseas online.',
		},
		white_box_3rd: {
			heading: 'Quick Access',
			paragraph:
				'The recipient can get the money without delay when remitting cryptocurrency.',
		},
	},
	round_monitor: {
		label: 'Encryption Technology',
		title: {
			one: 'Year-Round',
			two: 'Monitoring',
		},
		paragraph:
			'With advanced encryption technology, JPWorldPay prioritizes the safety of every transaction. We work hard to ensure that your 				transfers are secure, giving you peace of mind whenever you send or receive funds. Your sensitive information is protected at 				every step, and we continuously update our systems to defend against emerging threats.',
		cta_buttons: {
			one: 'Get Started',
		},
	},
	question_trade: {
		label: 'Money Transfer',
		title: {
			one: 'Transfer',
			two: 'Worldwide',
		},
		paragraph: {
			one: 'Transfer money to your recipient anywhere in the world with JPWorldPay. Transfer money online to friends and family anywhere in the world. It is fast, reliable, and easy to use, whether for personal or business purposes. Enjoy low fees and real-time tracking with every transfer.',
			two: 'Send instantly with confidence, backed by advanced security features. Stay connected and in control with 24/7 access and support.',
		},
		cta_buttons: {
			one: 'Get Started',
		},
	},

	ziga_sec: {
		label: 'JPWorldPay Transaction',
		title: {
			one: '0 Ziga Transaction ',
			two: 'Fee',
		},
		paragraph:
			'When withdrawing from wallets linked to other banks, there is no withdrawal fee if the money is sent from your JPWorldPay balance. This makes transferring funds more cost-effective and convenient, helping you save on unnecessary fees while enjoying a smooth transaction experience. Plus, JPWorldPay ensures fast processing times so your money arrives quickly.',
		cta_buttons: {
			one: 'Get Started',
		},
	},

	section_newsletter: {
		label: 'SUBSCRIBE NEWSLETTER',
		title: {
			one: 'Subscribe',
			two: '& Get A Latest Update',
		},
		description: {
			one: 'Subscribe us & recieve our offers and updates in your inbox directly.',
			two: 'Get in touch to learn how our JPWorldPay solution can increase your business.',
		},
		form: {
			placeholder: 'Email ID',
			button: 'SUBSCRIBE NOW',
		},
	},
};
